import React, { Suspense, lazy } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import ProtectedRoute from "./ProtectedRoutes";
import Loader from "../components/custom-loader/Loader";

const AppRoutes = () => {
  const [accessToken, setAccessToken] = React.useState(
    localStorage.getItem("vcuUserAccessToken"),
  );

  React.useEffect(() => {
    const handleStorageChange = () => {
      setAccessToken(localStorage.getItem("vcuUserAccessToken"));
    };

    window.addEventListener("storage", handleStorageChange);

    return () => {
      window.removeEventListener("storage", handleStorageChange);
    };
  }, []);

  const LoginPage = lazy(() => import("../pages/Auth/Login/Login"));
  const VerifyOtpPage = lazy(() => import("../pages/Auth/VerifyOtp/VerifyOtp"));
  const RegisterPage = lazy(() => import("../pages/Auth/Register/Register"));
  const RegisterSuccess = lazy(
    () => import("../pages/RegisterSuccess/RegisterSuccess"),
  );

  const HomePage = lazy(() => import("../pages/Home/Home"));
  const DashboardPage = lazy(() => import("../pages/Dashboard/Dashboard"));
  const LearningJourneyPage = lazy(
    () => import("../pages/LearningJourney/LearningJourney"),
  );
  const ResourceLibrary = lazy(
    () => import("../pages/ResourceLibrary/ResourceLibrary"),
  );
  const RecentMessages = lazy(
    () => import("../pages/RecentMessages/RecentMessages"),
  );
  const WeeklyReportPage = lazy(
    () => import("../pages/WeeklyReport/WeeklyReport"),
  );

  const ResourceById = lazy(
    () => import("../pages/ResourceLibrary/ResourceById/ResourceById"),
  );

  const WelocmePage = lazy(() => import("../pages/WelcomePage/WelcomePage"));
  const MyWeeklyReportsList = lazy(
    () => import("../pages/MyWeeklyReport/MyWeeklyReportList"),
  );

  const MyWeeklyReport = lazy(
    () => import("../pages/MyWeeklyReport/MyWeekly-report/MyWeeklyReport"),
  );

  const ServerErrorPage = lazy(
    () => import("../pages/ServerError/ServerError"),
  );

  const PageNotFound = lazy(() => import("../pages/PageNotFound/PageNotFound"));

  const FitbitCallback = lazy(
    () => import("../components/Fitbit-connection/FitbitCallback"),
  );

  const storedUserDetails = localStorage.getItem("vcuUserDetails");
  const hasLastLogin = (() => {
    if (!storedUserDetails) return false;

    try {
      const userDetails = JSON.parse(storedUserDetails);
      return Boolean(userDetails?.lastLogin);
    } catch {
      return false;
    }
  })();

  return (
    <Suspense
      fallback={
        <div>
          <Loader />
        </div>
      }
    >
      <Routes>
        <Route path="server-error" element={<ServerErrorPage />} />
        <Route path="*" element={<PageNotFound />} />

        {/* 🔓 Public Routes */}
        <Route
          path="/login"
          element={accessToken ? <Navigate to="/" replace /> : <LoginPage />}
        />

        <Route
          path="/verify-otp"
          element={
            accessToken ? <Navigate to="/" replace /> : <VerifyOtpPage />
          }
        />

        <Route
          path="/register"
          element={accessToken ? <Navigate to="/" replace /> : <RegisterPage />}
        />

        <Route
          path="/register-success"
          element={
            accessToken ? <Navigate to="/" replace /> : <RegisterSuccess />
          }
        />

        <Route path="/callback" element={<FitbitCallback />} />

        {/* 🔐 Protected Routes */}
        <Route
          path="/"
          element={
            <ProtectedRoute>
              <HomePage />
            </ProtectedRoute>
          }
        >
          <Route
            index
            element={
              hasLastLogin ? (
                <Navigate to="dashboard" replace />
              ) : (
                <Navigate to="welcomepage" replace />
              )
            }
          />
          <Route path="welcomepage" element={<WelocmePage />} />
          <Route path="dashboard" element={<DashboardPage />} />
          <Route
            path="learning-journey"
            element={<LearningJourneyPage handleRedirect={() => {}} />}
          />
          <Route
            path="resource-library"
            element={<ResourceLibrary handleRedirect={() => {}} />}
          />
          <Route path="recent-messages" element={<RecentMessages />} />
          <Route path="weekly-report/:weekId" element={<WeeklyReportPage />} />
          {/* below this is a same component use for lesson and resource detail by id as both has same design  */}
          <Route path="resource/:resourceId" element={<ResourceById />} />
          <Route path="lesson/:lessonId" element={<ResourceById />} />
          <Route path="myweekly-reportlist" element={<MyWeeklyReportsList />} />
          <Route
            path="myweekly-report/:reportId"
            element={<MyWeeklyReport />}
          />
        </Route>
      </Routes>
    </Suspense>
  );
};

export default AppRoutes;
